import { render, staticRenderFns } from "./ShopListModal.vue?vue&type=template&id=485f5bb6&scoped=true&"
import script from "./ShopListModal.vue?vue&type=script&lang=js&"
export * from "./ShopListModal.vue?vue&type=script&lang=js&"
import style0 from "./ShopListModal.vue?vue&type=style&index=0&id=485f5bb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f5bb6",
  null
  
)

export default component.exports